// extracted by mini-css-extract-plugin
var _1 = "LinkForm_controls__2f68e";
var _2 = "LinkForm_input__740ce";
var _3 = "LinkForm_newTab__5346b";
var _4 = "LinkForm_root__566c7";
export { _1 as "controls", _2 as "input", _3 as "newTab", _4 as "root" }
